<template>
  <div class="flex flex-col">
    <div class="mb-1">
      {{ $t('contacts.tags.label') }}
    </div>
    <div class="mb-2 flex flex-wrap" v-if="newTags.length > 0">
      <div
        class="mt-1 mr-1 flex items-center rounded bg-gray-300 py-1 pl-3"
        v-for="tag in newTags"
        :key="tag"
      >
        <span>{{ tag }}</span>
        <input type="hidden" name="tags[]" :value="tag" />
        <button
          type="button"
          class="ml-1 cursor-pointer px-2 text-sm outline-none hover:text-brand-500 focus:text-brand-500"
          @click="removeTag(tag)"
        >
          <span class="fal fa-times"></span>
        </button>
      </div>
    </div>
    <div class="relative">
      <input
        type="text"
        class="form-input w-full"
        maxlength="50"
        :placeholder="$t('contacts.tags.placeholder')"
        v-model="filter"
        @keydown.enter="addSelected"
        @keydown.down.prevent="moveSelection(1)"
        @keydown.up.prevent="moveSelection(-1)"
        @focus="active = true"
        @keydown.esc.prevent="(event) => event.target.blur()"
        @blur="active = false"
      />
      <div
        ref="results"
        class="border-grey-lighter absolute left-0 right-0 mb-20 flex flex-col overflow-hidden rounded border border-t-0 bg-white py-1 shadow-md"
        v-if="showResults"
      >
        <button
          type="button"
          :class="tagClasses(index)"
          @mousedown.prevent
          @click="addTag(tag)"
          @mouseover="selectedIndex = index"
          v-for="(tag, index) in filteredTags"
          :key="index"
        >
          {{ tag }}
        </button>
        <button
          v-if="!hasPerfectMatch"
          type="button"
          :class="tagClasses(filteredTags.length)"
          @mouseover="selectedIndex = filteredTags.length"
          @mousedown.prevent
          @click="addTag(trimmedFilter)"
        >
          {{ $t('contacts.tags.create_new') }} "{{ trimmedFilter }}"...
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
export default {
  props: {
    tags: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      required: false,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      selectedIndex: 0,
      newTags: [],
      filter: '',
      active: false,
    }
  },
  computed: {
    filteredTags() {
      return this.tags
        .filter((tag) => !this.newTags.includes(tag))
        .filter((tag) => tag.toLowerCase().indexOf(this.trimmedFilter.toLowerCase()) >= 0)
    },
    hasPerfectMatch() {
      return this.newTags.includes(this.trimmedFilter)
    },
    showResults() {
      return (
        this.active &&
        this.trimmedFilter !== '' &&
        (this.filteredTags.length > 0 || !this.hasPerfectMatch)
      )
    },
    trimmedFilter() {
      return this.filter.trim()
    },
  },
  methods: {
    addTag(tag) {
      if (!this.active || this.trimmedFilter === '') {
        return
      }

      this.newTags.push(tag)
      this.filter = ''
      this.selectedIndex = 0
    },
    removeTag(removeTag) {
      this.newTags = this.newTags.filter((tag) => tag !== removeTag)
    },
    tagClasses(index) {
      return (
        'outline-none text-left px-3 py-1 my-1 cursor-pointer max-w-full break-words' +
        (index == this.selectedIndex ? ' bg-brand-500 text-white' : '')
      )
    },
    addSelected(event) {
      if (this.trimmedFilter !== '') {
        event.preventDefault()
      }

      if (!this.showResults) {
        return
      }

      if (this.selectedIndex >= this.filteredTags.length) {
        this.addTag(this.trimmedFilter)
      } else {
        this.addTag(this.filteredTags[this.selectedIndex])
      }
    },
    moveSelection(by) {
      this.selectedIndex = (this.selectedIndex + by) % (this.filteredTags.length + 1)
      if (this.selectedIndex < 0) {
        this.selectedIndex = this.filteredTags.length
      }
    },
  },
  watch: {
    filter() {
      let results = this.$refs.results
      if (results == undefined) {
        return
      }

      nextTick(() => {
        results.scrollIntoView({
          block: 'nearest',
        })
      })
    },
  },
  mounted() {
    this.newTags = this.selected
  },
}
</script>
